import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from './../common/services/sharedService';
import { CommonConstants } from './../common/utilities/commonConstants';
import { RouteContextProvider } from './../common/services/routeContextProvider.service';
import { ActivitiHandlerService } from '../common/services/activitiHandler.service';
import { RouteHandlerService } from '../common/services/routeHandler.service';
import { SessionHandlerService } from '../common/services/sessionHandler.service';
import { adobe_analytics_service } from '../common/services/adobe_analytics_service';

@Component({
    templateUrl: './multitabFailed.template.html',
    styleUrls: ['./multitabFailed.style.scss'],
})

export class MultitabFailedComponent implements OnInit {

    private isbrowserBackPressed: boolean;
    public ProdType: string;

    constructor(
        private _sharedService: SharedService,
        private _routeContextProvider: RouteContextProvider,
        private _sessionHandler: SessionHandlerService,
        private _adobe_analytics_service: adobe_analytics_service
    ) { }

    public ngOnInit() {
        // browser back button changes
        this.ProdType = this._sessionHandler.GetSession(CommonConstants.CookieKeys.InsProductType);
        this._sessionHandler.FlushAll();
        this.isbrowserBackPressed = this._sharedService.getData('brwoserback');
        if (this.isbrowserBackPressed) {
            this._routeContextProvider.NavigateToView([CommonConstants.Routes.MultitabFailed]);
        }
    }
    public ExploreMore() {
        this._adobe_analytics_service.exploreMoreProducts('multiTabFailed', 'https://www.bajajfinservmarkets.in');
        window.open('https://www.bajajfinservmarkets.in', '_self');
    }
}
